import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import { CardHeader } from "@mui/material";
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";
import MDTypography from "components/MDTypography";
import Swal from "sweetalert2";
import SearchAccSessionReq from "../../Classes/Models/Requests/AccountingSessions/CreateAccountingSessionReq";
import { useNavigate } from "react-router-dom";
import SessionsApi from "../../Classes/API/Administration/SessionsApi";
import DataTable from "examples/Tables/DataTable";
import AccountingApi from "../../Classes/API/AccountingApi";
import { useContext } from "react";
import { UserContext } from "App";
import PayFromBalanceReq from "../../Classes/Models/Requests/Accounting/PayFromBalanceReq";
import PayFromBalanceButton from "layouts/AccountingSessions/PayFromBalanceButton";
import AddmissionButton from "layouts/AccountingSessions/AddmissionButton";
import SearchStringOrIntReq from "../../Classes/Models/Requests/SearchStringOrIntReq";

const IMPLEMENTED_TYPES = ["Stay", "Package"];

const SessionsTable = ({
  setIsLoaded,
  deleteAllSessions,
  refundSession,
  accountingSessions,
  deleteAccountingSession,
  batchDeleteAccountingSessions,
  type,
}) => {
  if (!IMPLEMENTED_TYPES.includes(type))
    throw new Error(`Type ${type} not implemented yet in SessionsTable.`);

  const CurrentUser = useContext(UserContext);
  let navigate = useNavigate();

  const [SearchReq, setSearchReq] = useState(new SearchAccSessionReq());
  const [SelectedSessions, setSelectedSessions] = useState([]);
  const [SessionsCount, setSessionsCount] = useState(0);
  const [DummyVal, setDummyVal] = useState(0);
  const [SelectedSession, setSelectedSession] = useState(null);
  const [RemovedSession, setRemovedSession] = useState(null);

  useEffect(() => {
    setSessionsCount(SelectedSessions.length);
    setDummyVal(DummyVal + 1);
    console.log("SessionsCount", SessionsCount, SelectedSessions);
  }, [SelectedSessions]);

  useEffect(() => {
    if (SelectedSession != null) {
      console.log("AddToSelectedSessions", SelectedSessions, SelectedSession);
      if (SelectedSessions.find((x) => x.id == SelectedSession.id)) {
        Swal.fire({
          title: "Error",
          text: "Session already added",
          icon: "error",
          confirmButtonText: "Ok",
        });
        return;
      }
      let newSelectedSessions = [...SelectedSessions];
      newSelectedSessions.push({ ...SelectedSession });
      setSelectedSessions([...newSelectedSessions]);
      setSelectedSession(null);
    }
  }, [SelectedSession]);

  useEffect(() => {
    if (RemovedSession != null) {
      console.log("RemoveFromSelectedSessions", SelectedSessions, RemovedSession);
      let newSelectedSessions = [...SelectedSessions];
      newSelectedSessions = newSelectedSessions.filter((x) => x.id != RemovedSession.id);
      setSelectedSessions([...newSelectedSessions]);
      setRemovedSession(null);
    }
  }, [RemovedSession]);

  const RefundTableColumns =
    type === "Package" ? [{ Header: "Pay/Refund", accessor: "Pay", align: "center" }] : [];

  const TableColumns = [
    // { Header: "Acc. Session ID", accessor: "Id", align: "left" },
    { Header: "Session", accessor: "Session", align: "left" },
    { Header: "Therapist", accessor: "Therapist", align: "left" },
    { Header: "Appointment", accessor: "Appointment", align: "left" },
    { Header: "Addmission", accessor: "Addmission", align: "left" },
    ...RefundTableColumns,
    { Header: "Details", accessor: "Details", align: "center" },
    { Header: "Delete", accessor: "Delete", align: "center" },
  ];

  const [TableDataRows, setTableDataRows] = useState([]);

  const GetOptions = (session) => {
    if (
      CurrentUser.userType != "Admin" &&
      CurrentUser.userType != "Therapist" &&
      CurrentUser.userType != "AccountingEmployee" &&
      CurrentUser.userType != "AppointmentEmployee"
    ) {
      Swal.fire({
        title: "Sorry, you do not have this permission.",
        text: "Visit your admin to request this permission.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    navigate("/AccountingSessions/Details", {
      state: {
        SearchSession: session,
      },
    });
  };

  const MakeTableRow = (session, index) => {
    console.log("MakeTableRow", session);

    return {
      Id: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {session.id}
        </MDTypography>
      ),
      Session: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          <button
            className="btn btn-outline-success mr-2"
            onClick={() => {
              setSelectedSession(session);
            }}
          >
            +
          </button>
          {session.id} - {session.sessionName}
        </MDTypography>
      ),

      PaidFor: (
        <input
          id={"S.isPaidFor" + session.id}
          type="checkbox"
          disabled
          checked={session.isPaidFor ? "on" : ""}
        />
      ),
      Addmission: <AddmissionButton AccSession={session} setIsLoaded={setIsLoaded} />,
      Therapist: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {session.therapistName}
        </MDTypography>
      ),
      Appointment: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {session.appointmentTime}
        </MDTypography>
      ),
      Details: (
        <button
          onClick={() => {
            GetOptions(session);
          }}
          className="btn btn-dark"
        >
          <Icon>settings</Icon>
        </button>
      ),
      Pay: (
        <>
          {session.isPaidFor ? (
            <button
              onClick={() => {
                refundSession(session);
              }}
              className="btn btn-danger"
            >
              refund {session.finalPrice} EGP
            </button>
          ) : (
            <PayFromBalanceButton Session={session} setIsLoaded={setIsLoaded} />
          )}
        </>
      ),
      Delete: (
        <button
          onClick={() => {
            deleteAccountingSession(session);
            // DeleteAccountingSession(session);
          }}
          className="btn btn-dark"
        >
          <Icon>delete</Icon>
        </button>
      ),
    };
  };

  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((session, index) => {
      rows.push(MakeTableRow(session, index));
    });
    setTableDataRows(rows);
  };

  // const AddToSelectedSessions = (session) => {
  //     console.log("AddToSelectedSessions", SelectedSessions, session)
  //     if(SelectedSessions.find(x => x.id == session.id)){
  //         Swal.fire({
  //             title: 'Error',
  //             text: 'Session already added',
  //             icon: 'error',
  //             confirmButtonText: 'Ok'
  //         })
  //         return;
  //     }
  //     let newSelectedSessions = [...SelectedSessions];
  //     newSelectedSessions.push({...session});
  //     setSelectedSessions([...newSelectedSessions]);
  // }

  useEffect(() => {
    if (accountingSessions.length > 0) {
      let sorted = accountingSessions.sort((a, b) => {
        const dateA = new Date(a.appointmentTime);
        const dateB = new Date(b.appointmentTime);

        return dateB - dateA;
      });
      RefreshTable(sorted);
    } else {
      setTableDataRows([]);
    }
  }, [accountingSessions]);

  return (
    <>
      <Card sx={{ marginBottom: 6 }}>
        <CardHeader title="Batch Operations" />
        <div className="BatchOperations">
          <div>{<h3>{SelectedSessions.length} Sessions Selected</h3>}</div>
          <div className="BatchSessions">
            {SelectedSessions.map((session, index) => {
              return (
                <div className="BatchSession" key={index}>
                  <div className="BatchSessionId">Id: {session.id}</div>
                  <div className="BatchSessionName">{session.sessionName}</div>
                  <button
                    onClick={() => {
                      setRemovedSession(session);
                    }}
                    className="btn btn-outline-danger"
                  >
                    <Icon>delete</Icon>
                  </button>
                </div>
              );
            })}
          </div>
        </div>
        <div className="BatchSessionButtons">
          <button
            className="btn btn-dark"
            disabled={SelectedSessions.length < 1}
            onClick={() => {
              batchDeleteAccountingSessions(SelectedSessions);
            }}
          >
            {type === "Stay" ? "Remove" : "Delete"}
          </button>
        </div>
      </Card>

      <Card>
        <MDBox
          mx={2}
          mt={-3}
          py={3}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
        >
          <MDTypography variant="h6" color="white">
            Accounting Sessions Table
          </MDTypography>
          {type === "Package" && (
            <button
              onClick={() => {
                deleteAllSessions();
              }}
              className="btn btn-danger"
              style={{ float: "right" }}
            >
              Delete All Sessions
            </button>
          )}
        </MDBox>
        <MDBox pt={3}>
          <DataTable
            table={{ columns: TableColumns, rows: TableDataRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        </MDBox>
      </Card>
    </>
  );
};

export default SessionsTable;
